import React from "react";
import { iconProps } from "../../../../Helper";

export const GenerateImgIcon = ({ className }: iconProps) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame 1984079960">
        <path
          className={className}
          id="Star 1"
          d="M2.5 0L3.04018 1.45982L4.5 2L3.04018 2.54018L2.5 4L1.95982 2.54018L0.5 2L1.95982 1.45982L2.5 0Z"
          fill="white"
        />
        <path
          className={className}
          
          id="Subtract"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 3.91602V10.1282C0.5 10.4649 0.616667 10.75 0.85 10.9833C1.08333 11.2167 1.36839 11.3333 1.70517 11.3333H10.6282C10.9649 11.3333 11.25 11.2167 11.4833 10.9833C11.7167 10.75 11.8333 10.4649 11.8333 10.1282V1.20517C11.8333 0.868389 11.7167 0.583333 11.4833 0.35C11.25 0.116667 10.9649 0 10.6282 0H4.66675V1H10.6282C10.6795 1 10.7265 1.02139 10.7692 1.06417C10.8119 1.10683 10.8333 1.15383 10.8333 1.20517V10.1282C10.8333 10.1795 10.8119 10.2265 10.7692 10.2692C10.7265 10.3119 10.6795 10.3333 10.6282 10.3333H1.70517C1.65383 10.3333 1.60683 10.3119 1.56417 10.2692C1.52139 10.2265 1.5 10.1795 1.5 10.1282V3.91602H0.5ZM9.71783 8.83333H2.66667L4.3205 6.641L5.65383 8.34617L7.52567 5.91033L9.71783 8.83333Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
